import { put, take, call } from 'redux-saga/effects';
import {
  setPreferredLanguage,
  updateLanguageRequestError,
  updateLanguage,
} from '../../../reducers/translationSlice';
import withLoading from '../../../sagas/loadingSaga';

export default function* updateLanguageSaga(api) {
  while (true) {
    const updateLanguageAction = yield take(updateLanguage.type);
    yield* withLoading(function* () {
      const { language } = updateLanguageAction.payload;
      yield call(updateLanguageRequest, api, language);
    });
  }
}

/** Create request to update preferred language
 * @param {string} accessToken - User access token
 * @param {string} updatedLanguagePreferences - language preference
 */
function* updateLanguageRequest(api, languageValue) {
  try {
    yield call(api.updateLelyPreferredLanguage, languageValue);
    yield put(setPreferredLanguage(languageValue));
  } catch (error) {
    yield put(updateLanguageRequestError(error));
  }
}
